import { Type } from 'class-transformer';
import { GLSubcategorySelectorResultDto } from '../../common/gl-account/glsubcategory-selector-result-dto';

export class MiscInvoiceGLSubCategoryResultDto {
    defaultSubCategoryCode: string;
    @Type(() => GLSubcategorySelectorResultDto)
    subCategories: GLSubcategorySelectorResultDto[];
}
